import * as React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./DropdownMenu";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

const Select = ({ 
  value, 
  onChange, 
  options, 
  placeholder = "Seleccionar...",
  className,
  disabled = false,
  forceTop = false // Para forzar que se abra hacia arriba en móvil
}) => {
  const [open, setOpen] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(false);
  
  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const selectedOption = options.find(opt => {
    const optValue = typeof opt === 'object' ? opt.value : opt;
    return optValue === value || optValue === String(value);
  });
  
  const displayValue = selectedOption 
    ? (typeof selectedOption === 'object' ? selectedOption.label : selectedOption)
    : placeholder;

  const handleSelect = (optionValue) => {
    onChange(optionValue === '' ? null : optionValue);
    setOpen(false);
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger
        disabled={disabled}
        className={cn(
          "w-full text-sm md:text-base text-center font-bold bg-card border-2 border-primary/20 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all hover:border-primary/40 appearance-none cursor-pointer min-h-[44px] flex items-center justify-between gap-2",
          className
        )}
      >
        <span className="flex-1">{displayValue}</span>
        <ChevronDown className={cn(
          "w-4 h-4 text-primary transition-transform flex-shrink-0",
          open && "transform rotate-180"
        )} />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side={isMobile || forceTop ? "top" : "bottom"}
        align="start"
        className="w-[var(--radix-dropdown-menu-trigger-width)] max-h-[300px] overflow-y-auto z-[100]"
        sideOffset={5}
        collisionPadding={20}
      >
        {options.map((option, index) => {
          const optionValue = typeof option === 'object' ? option.value : option;
          const optionLabel = typeof option === 'object' ? option.label : option;
          const isSelected = optionValue === value || String(optionValue) === String(value);
          
          return (
            <DropdownMenuItem
              key={index}
              onClick={() => handleSelect(optionValue)}
              className={cn(
                "cursor-pointer text-center justify-center py-2.5",
                isSelected && "bg-primary/10 text-primary font-semibold"
              )}
            >
              {optionLabel}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export { Select };
